import { Alert, Button, Modal, Text } from "@vericus/cadmus-ui";

import { create, useModal } from "@ebay/nice-modal-react";

import { formatDateFull } from "@/utils/datetime";

import * as styles from "../styles.css";

/**
 * NiceModal to confirm if the user wants to finalise their group early.
 */

interface FinaliseGroupModalProps {
  onFinalise: () => void;
  deadline?: string | null;
}

export const FinaliseGroupModal = create<FinaliseGroupModalProps>(
  (props: FinaliseGroupModalProps) => {
    const modal = useModal();
    const { onFinalise, deadline } = props;
    return (
      <Modal.Root open={modal.visible}>
        <FinaliseGroupModalContent
          onClose={() => modal.remove()}
          onFinalise={onFinalise}
          deadline={deadline}
        />
      </Modal.Root>
    );
  }
);

interface Props extends FinaliseGroupModalProps {
  onClose: () => void;
}

function FinaliseGroupModalContent(props: Props) {
  return (
    <Modal.Content
      className={styles.finaliseModalContent}
      withCloseButton={false}
      width={572}
    >
      <div>
        <Modal.Title asChild>
          <Text kind="headingFour">Finalise Group Early?</Text>
        </Modal.Title>
        <Modal.Description asChild>
          <Text kind="bodyMd" textAlign="center">
            {props.deadline && (
              <>
                Self-enrolment is open until{" "}
                {formatDateFull(new Date(props.deadline))}.
                <br />
              </>
            )}
            Finalising now will lock this group and its members from
            participating in self-enrolment.
            <br />
            Are you sure you want to proceed?
          </Text>
        </Modal.Description>
      </div>
      <Alert severity="warning" size="sm">
        Please do this only with the consent of all enrolled group members
      </Alert>
      <div className={styles.finaliseModalActions}>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          kind="secondary"
          onClick={(e) => {
            e.preventDefault();
            props.onFinalise();
            props.onClose();
          }}
        >
          Finalise Group
        </Button>
      </div>
    </Modal.Content>
  );
}
